import { useMemo } from "react";

import { useRecoilValue } from "recoil";

import { KHeaderWidgetProps } from "..";
import { KHeaderWidget } from "../../../../models/configuration/components/kHeaderWidget";
import { Type } from "../../../../models/configuration/definitions/widget";
import { useInitConfig } from "../../../../providers/config/hooks/init";
import { frontEditState } from "../../../../providers/frontEdit/atoms/frontEdit";
import useFrontEditEditable from "../../../../providers/frontEdit/hooks/useFrontEditEditable";
import { getKHeaderWidgetConfiguration, translateKHeaderWidgetConfiguration } from "../utils";

export type UseKHeaderWidgetSelect = KHeaderWidgetProps | undefined;

// Retreive KHeaderWidget configuration from WidgetId in a hook way
export const useKHeaderWidgetSelect = ({
  widgetId,
}: {
  widgetId: KHeaderWidget["id"];
}): UseKHeaderWidgetSelect => {
  const { initConfig } = useInitConfig();

  const frontEdit = useRecoilValue(frontEditState);
  const { widgetConfiguration: frontEditWidgetConfig } = useFrontEditEditable(
    Type.Header,
    widgetId,
  );

  const widgetConfiguration = useMemo(() => {
    const configuration = initConfig?.config?.jsonConfig
      ? getKHeaderWidgetConfiguration(initConfig.config.jsonConfig, widgetId)
      : undefined;

    // Front Edit Case
    if (frontEdit && frontEditWidgetConfig) {
      const translatedHeaderConfig: KHeaderWidgetProps | undefined =
        translateKHeaderWidgetConfiguration(frontEditWidgetConfig as KHeaderWidget);
      return {
        ...(configuration || {}),
        ...translatedHeaderConfig,
      };
    }
    // Default case
    return configuration;
  }, [initConfig?.config?.jsonConfig, widgetId, frontEdit, frontEditWidgetConfig]);

  return widgetConfiguration;
};
